import React from "react";
import useStyles from "./style";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const CustomercareDelete = (props) => {
  const { openDialog, handleClose, onSubmit, row } = props;
  const classes = useStyles();

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle className={classes.dialogTitle}>Delete Customer Care User</DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.dialogContentText}>
          Are you sure you want to delete the customer care user{" "}
          <strong>{row?.fullName}</strong> ({row?.id})? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className={classes.cancelButton} onClick={handleClose}>
          Cancel
        </Button>
        <Button className={classes.deleteButton} onClick={onSubmit} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomercareDelete;
